import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './About.module.less';
import { setAboutVisible, setTick } from '../../actions/layout';
import { APP_VERSION, APP_VERSION_D, DEVELOPER_URL } from '../../config';
import { cacheKeys } from '../../constants/storageKeys';
import { logging } from '../../actions/log';

const selectTick = createSelector(
  state => state.layout,
  layout => layout.isTick,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const isTick = useSelector(selectTick);
  const [version, setVersion] = useState(APP_VERSION);
  const logInfoData = useSelector(selectLogInfo);
  const handleAboutHidden = () => {
    dispatch(setAboutVisible(false));
  };

  const handleClickTick = useCallback(() => {
    localStorage.setItem('localAboutTick', !isTick);
    dispatch(setTick(!isTick));
  }, [dispatch, isTick]);

  useEffect(() => {
    const isTickChecked = localStorage.getItem('localAboutTick');
    dispatch(setTick(isTickChecked === 'true'));

    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO) || '{}';
    try {
      const startInfo = JSON.parse(startInfoStr);
      setVersion(startInfo.isDStore ? APP_VERSION_D : APP_VERSION);
    } catch (error) {}
  }, [dispatch]);

  const handleDeveloper = useCallback(
    ev => {
      // 点击 商业合作 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'business',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      window.open(DEVELOPER_URL);
    },
    [dispatch, logInfoData],
  );

  return (
    <div>
      <div className={styles.About}>
        <div className="TopBanner">
          <span className="closeIcon" onClick={handleAboutHidden} />
        </div>
        <div className="BottomBanner">
          <div className="version">版本号：{version}</div>
          <div className="msg">
            <div className="msg_item">
              <a
                href="https://s1.lenovomm.cn/pcstore/html/clause.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                软件许可协议
              </a>
            </div>
            <div className="msg_item">
              <a
                href="https://s1.lenovomm.cn/pcstore/html/open_comp.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                开源组件许可
              </a>
            </div>
            <div className="msg_item">
              <a
                href="https://s1.lenovomm.cn/pcstore/html/privacy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                隐私权声明
              </a>
            </div>
            <div className="msg_item" onClick={handleDeveloper}>
              <span href="#" target="_blank" rel="noopener noreferrer">
                商务合作
              </span>
            </div>
          </div>
          {/* <div className="footmsg">商店内容由 联想（北京）有限公司提供</div> */}
          <div className="footmsg">COPYRIGHT@${new Date().getFullYear()}</div>
        </div>
      </div>
    </div>
  );
});
